export default {
  submenuFavorite: {
    position: 'relative',
  },
  subMenuFavoriteItem: (isFirst, isLast) => ({
    position: 'relative',
    padding: '4px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => theme.customValues.sidebar.textColor,
    ':hover': {
      color: (theme) => theme.palette.black.main,
      backgroundColor: (theme) => theme.customValues.sidebar.bgHover,
    },
    '&.Mui-selected': {
      color: (theme) => theme.palette.black.main,
      backgroundColor: (theme) => theme.customValues.sidebar.bgHover,

      ':hover': {
        color: (theme) => theme.palette.black.main,
        backgroundColor: (theme) => theme.customValues.sidebar.bgHover,
      },
    },
    '&.Mui-disabled': {
      backgroundColor: (theme) => theme.palette.lightGray.main,
      opacity: '1',
      '.MuiListItemText-root': {
        opacity: '0.38',
      },
    },
    '&::before': {
      content: "''",
      position: 'absolute',
      left: '28px',
      width: '1px',
      backgroundColor: (theme) => theme.customValues.sidebar.pseudoElementColor,
      top: isFirst ? 0 : '-8px',
      bottom: isLast ? 0 : '-8px',
    },
  }),
  subMenuFavoriteItemInnerWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dummyMarginElement: { width: '22px' },
  title: {
    paddingLeft: '36px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
    maxWidth: '150px',
  },
  removeButton: {
    padding: '4px',
    fontSize: '18px',
  },
};
